// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import {
    getCategoryExperiences as listCategoryExperiencesAPI,
    getCategoryExperience as getCategoryExperienceAPI,
    addCategoryExperience as addCategoryExperienceAPI,
    updateCategoryExperience as updateCategoryExperienceAPI,
    deleteCategoryExperience as deleteCategoryExperienceAPI,
} from '../../helpers/';

import { categoryExperiencesApiResponseError, categoryExperiencesApiResponseSuccess } from './actions';
import { CategoryExperiencesActionTypes } from './constants';


/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getCategoryExperience({ payload: { id } }) {
    try {
        const response = yield call(getCategoryExperienceAPI, id );
        const categoriaItem = response.data.data;
        yield put(categoryExperiencesApiResponseSuccess(CategoryExperiencesActionTypes.GET_CATEGORY_EXPERIENCE, categoriaItem));
    } catch (error) {
        yield put(categoryExperiencesApiResponseError(CategoryExperiencesActionTypes.GET_CATEGORY_EXPERIENCE, error));
    }
}

function* addCategoryExperience({payload:categoria}){
    try{
        const response = yield call(addCategoryExperienceAPI,{...categoria})
        const categoriaItem = response.data
        yield put(categoryExperiencesApiResponseSuccess(CategoryExperiencesActionTypes.ADD_CATEGORY_EXPERIENCE,categoriaItem))
    } catch(error){
        yield put(categoryExperiencesApiResponseError(CategoryExperiencesActionTypes.ADD_CATEGORY_EXPERIENCE,error))
    }
}

function* updateCategoryExperience({payload:categoria}){
    try{
        const response = yield call(updateCategoryExperienceAPI,{...categoria})
        const categoriaItem = response.data.data
        yield put(categoryExperiencesApiResponseSuccess(CategoryExperiencesActionTypes.UPDATE_CATEGORY_EXPERIENCE,categoriaItem))
    }catch(error){
        yield put(categoryExperiencesApiResponseError(CategoryExperiencesActionTypes.UPDATE_CATEGORY_EXPERIENCE,error))
    }
}
function* deleteCategoryExperience({payload:{id}}){
    try{
        const response = yield call(deleteCategoryExperienceAPI,id)
        const categoriaItem = response.data.id
        yield put(categoryExperiencesApiResponseSuccess(CategoryExperiencesActionTypes.DELETE_CATEGORY_EXPERIENCE,categoriaItem))
    }catch(error){
        yield put(categoryExperiencesApiResponseError(CategoryExperiencesActionTypes.DELETE_CATEGORY_EXPERIENCE,error))
    }
}

/**
 * List contactos
 */
function* listCategoriesExperience({payload:params}) {
    try {
        const response = yield call(listCategoryExperiencesAPI, { ...params });
        const listaCategorias = response.data.data;
        yield put(categoryExperiencesApiResponseSuccess(CategoryExperiencesActionTypes.LIST_CATEGORIES_EXPERIENCE, listaCategorias));
    } catch (error) {
        yield put(categoryExperiencesApiResponseError(CategoryExperiencesActionTypes.LIST_CATEGORIES_EXPERIENCE, error));
    }
}


export function* watchGetCategoryExperience(): any {
    yield takeEvery(CategoryExperiencesActionTypes.GET_CATEGORY_EXPERIENCE, getCategoryExperience);
}

export function* watchListCategoriesExperience(): any {
    yield takeEvery(CategoryExperiencesActionTypes.LIST_CATEGORIES_EXPERIENCE, listCategoriesExperience);
}

export function* watchAddCategoryExperience():any{
    yield takeEvery(CategoryExperiencesActionTypes.ADD_CATEGORY_EXPERIENCE,addCategoryExperience)
}
export function* watchUpdateCategoryExperience():any{
    yield takeEvery(CategoryExperiencesActionTypes.UPDATE_CATEGORY_EXPERIENCE,updateCategoryExperience)
}
export function* watchDeleteCategoryExperience():any{
    yield takeEvery(CategoryExperiencesActionTypes.DELETE_CATEGORY_EXPERIENCE,deleteCategoryExperience)
}


function* categoryExperiencesSaga(): any {
    yield all([
        fork(watchGetCategoryExperience),
        fork(watchListCategoriesExperience),
        fork(watchAddCategoryExperience),
        fork(watchUpdateCategoryExperience),
        fork(watchDeleteCategoryExperience),
    ]);
}

export default categoryExperiencesSaga;
